import React, { FC, useRef } from 'react';
import type { PaymentChannelsGrowYourBusinessProps } from '@/types';
import { ContentManager } from '../content-manager';
import { Image } from '../image';
import { TextCols } from '../text-cols';
import { useInView } from '@/hooks/reveal-in-view';

export const PaymentChannelsGrowYourBusiness: FC<
  PaymentChannelsGrowYourBusinessProps
> = ({ content, card }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="paymentChannelsGrowYourBusiness">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={521} />
      </div>
      <div className="wrapper wrapper_lg">
        <div
          className="paymentChannelsGrowYourBusiness--card"
          ref={ref}
          style={{
            transform: isInView ? 'none' : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
          }}
        >
          <div className="paymentChannelsGrowYourBusiness--card-text">
            {card.title && (
              <ContentManager
                content={card.title}
                className="paymentChannelsGrowYourBusiness--card-title"
                style={{
                  transform: isInView ? 'none' : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
                }}
              />
            )}
            {card.description && (
              <ContentManager
                content={card.description}
                className="paymentChannelsGrowYourBusiness--card-description"
                style={{
                  transform: isInView ? 'none' : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
                }}
              />
            )}
          </div>
          {card.image?.file?.url && (
            <Image
              className="paymentChannelsGrowYourBusiness--card-image"
              src={card.image as any}
              alt={card.image.title}
              animateInView
              options={{
                sizes: {
                  exec: [
                    {
                      width: 704,
                      height: 663,
                    },
                  ],
                },
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
};
